import { usePermission } from "../../hooks/accessControl";
import { useParams } from "react-router-dom";

const RestrictedComponent = (props) => {
  const { children, resource, action, comp } = props;
  let { branchId } = useParams();
  const hasPermission = usePermission(branchId, resource, action);
  return hasPermission ? children : comp;
};
export default RestrictedComponent;
